"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LocalPhone_1 = __importDefault(require("@material-ui/icons/LocalPhone"));
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const PreQualificationDeclinedAdsOnlyLanguage_1 = __importDefault(require("../components/PreQualificationDeclinedAdsOnlyLanguage"));
function PreQualificationDeclinedAdsOnlyPage() {
    const history = (0, react_router_dom_1.useHistory)();
    const redirectToWizard = () => {
        history.push({
            pathname: config_1.WIZARD_URL,
            state: {
                step: 'PRE-QUALIFICATION',
                fullApp: true,
            },
        });
    };
    const location = (0, react_router_dom_1.useLocation)();
    const lenderStatusMessage = location?.state?.lenderStatusMessage;
    return ((0, jsx_runtime_1.jsx)("div", { className: "declined-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "content", children: [(0, jsx_runtime_1.jsx)("h1", { className: "first-title", children: "Pre-qualification" }), (0, jsx_runtime_1.jsx)("p", { className: "first-subtitle", children: "Thank you for your interest in the Alphaeon Credit Card." }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(PreQualificationDeclinedAdsOnlyLanguage_1.default, { lenderStatusMessage: lenderStatusMessage, redirectToWizard: () => redirectToWizard() }) }), (0, jsx_runtime_1.jsxs)("div", { className: "info-container", children: [(0, jsx_runtime_1.jsx)(LocalPhone_1.default, {}), ' ', (0, jsx_runtime_1.jsxs)("div", { className: "number-container", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: `tel:${config_1.CONTACT_NUMBER}`, children: config_1.CONTACT_NUMBER }) }), ' ', (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("a", { href: `tel:${config_1.TDD_TTY_NUMBER}`, children: ["(TDD/TTY ", config_1.TDD_TTY_NUMBER, ")"] }) })] })] })] }) }));
}
exports.default = PreQualificationDeclinedAdsOnlyPage;
